// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form-wrapper":"assign-award-leader__form-wrapper--WFKmM","formWrapper":"assign-award-leader__form-wrapper--WFKmM"};